import watchNewSimcardsRequest from './newSimcardsOrder';
import watchGetSelectOptions from './getSelectOptions';

const watchOrderSimcardWizard = [
  watchNewSimcardsRequest,
  watchGetSelectOptions
];

export default watchOrderSimcardWizard;
